import $ from 'jquery'
import _ from 'underscore'
import Backbone from 'backbone'
import Parse from 'parse'
import BaseParseObject from './BaseParseObject'

'use strict'

export const ObservingListAux = BaseParseObject.extend('ObservingListAux', {
    setDefaults: function (data) {
      // create an ACL object to grant access to the current user
      var acl = new Parse.ACL()

      // deny public read access
      acl.setPublicReadAccess(false)

      // grant read to current user
      acl.setReadAccess(Parse.User.current().id, true)
      // grant write to current user
      acl.setWriteAccess(Parse.User.current().id, true)

      // set this ACL object to the ACL field
      this.setACL(acl)

      // set the object attributes
      if (data) {
        if (data.observingList) {
          this.set('observingList', data.observingList)
        }

        if (data.skyObjects) {
          this.set('skyObjects', data.skyObjects)
        }
      }

      this.set('user', Parse.User.current())

      return this
    },
    update: function (data, updateAccess) {
      var acl = new Parse.ACL()

      if (!this.get('ACL') || updateAccess) {
        // create an ACL object to grant access to the current user

        // deny public read access
        acl.setPublicReadAccess(false)

        // grant read to current user
        acl.setReadAccess(Parse.User.current().id, true)
        // grant write to current user
        acl.setWriteAccess(Parse.User.current().id, true)

        // set this ACL object to the ACL field
        this.setACL(acl)
      }

      // set the object attributes
      if (data) {
        if (data.observingList) {
          this.set('observingList', data.observingList)
        }

        if (data.skyObjects) {
          this.set('skyObjects', data.skyObjects)
        }
      }

      this.set('user', Parse.User.current())

      // save the object
      return this.save().then(
        (item) => {
          // The save was successful.
          Backbone.trigger('observingLists:updated', item)
        },
        (error) => {
          // The save failed.  Error is an instance of Parse.Error.
          Backbone.trigger('errors:parseReturned', error)
        }
      )
    },
    delete: function () {
      // delete the object
      // set the object's `deleted` status to true
      this.set('deleted', true)
      return this.save().then(
        (result) => {
          Backbone.trigger('observingListAuxs:deleted', result)
        },
        (error) => {
          // The remote operation failed.  Error is an instance of Parse.Error.
          Backbone.trigger('errors:parseReturned', error)
        }
      )
    }

  })

export default ObservingListAux
